import constants from '../../common/constants'

export const sortFacetsByPriority = (baseFacets = [], currentFacets) => {
  if (baseFacets.length === 0) return currentFacets

  const sortedFacetsByPriority = []
  const facetNames = [...new Set(baseFacets.concat(currentFacets.map((facet) => facet.name.split('.')[1])))]

  facetNames.forEach((facetName) => {
    const facet = currentFacets.filter((facet) => facet.name.includes(facetName))[0]
    if (facet) sortedFacetsByPriority.push(facet)
  })
  return sortedFacetsByPriority
}

const filterAllowedFacets = (facets, facetsWhiteList, comesFromSearchPage) => {
  return facets
    ? Object.entries(facets)
        .filter((entry) => entry[0] !== 'categorias')
        .filter((entry) => (facetsWhiteList.length > 0 ? facetsWhiteList.includes(entry[0]) : comesFromSearchPage))
    : []
}

const filterAndSortFacets = (facets, facetsWhiteList, comesFromSearchPage, includeUnSortableFilters) => {
  const filteredFacets = filterAllowedFacets(facets, facetsWhiteList, comesFromSearchPage)

  return filteredFacets
    .map(([facetName, FacetItems]) => {
      const facetBase = {
        name: facetName,
        ...(FacetItems.id && { id: FacetItems.id }),
      }

      if (includeUnSortableFilters && constants.FILTERS.UNSORTABLE_FILTER.includes(facetName)) {
        return {
          ...facetBase,
          sortable: false,
          values: FacetItems,
        }
      }

      return {
        ...facetBase,
        sortable: true,
        items: Object.entries(FacetItems)
          .filter(([facetId]) => facetId !== 'id')
          .map(([filterName, filterCount]) => ({ name: filterName, count: filterCount })),
      }
    })
    .sort((a, b) => (b.items && a.items ? b.items.length - a.items.length : 1))
}

export const processFacets = (facets, facetsWhiteList, comesFromSearchPage, includeUnSortableFilters) => {
  let parsedFacets = filterAndSortFacets(facets, facetsWhiteList, comesFromSearchPage, includeUnSortableFilters)

  if (facetsWhiteList.length > 0) {
    parsedFacets = facetsWhiteList
      .map((facet) => parsedFacets.find((parsedFacet) => parsedFacet.name === facet))
      .filter((facet) => facet)
  }

  const baseFilters = constants.FILTERS.BASE_CATEGORY_FILTERS
  parsedFacets = sortFacetsByPriority(baseFilters, parsedFacets)

  parsedFacets = parsedFacets.slice(0, constants.FILTERS.MAX_CATEX_FILTERS)
  return parsedFacets
}
